import mediator from "@tvg/mediator";
import { get } from "lodash";
import { ProgramPageMediatorEventType } from "@tvg/ts-types/Amplitude";
import { track } from "../../amplitude";
import { EventProps, ProgramPageData, ModuleEventProps } from "./types";
import { EVENT_NAME } from "./constants";
import { BaseEventProps } from "../../types";
import { COMMON_EVENT_NAMES } from "../../constants";

export default () => {
  mediator.base.subscribe(
    ProgramPageMediatorEventType.URP_RUNNER_SELECTION,
    (data: ProgramPageData) => {
      track<EventProps>(EVENT_NAME.URP_RUNNER_SELECTION, {
        [BaseEventProps.EVENT_CATEGORY]: "Selection",
        [ModuleEventProps.PLACE_TYPE]: get(data, "payload.label"),
        [BaseEventProps.MODULE]: get(data, "payload.module", "Race Card"),
        [BaseEventProps.ALTERNATE_SELECTION]: get(
          data,
          "payload.alternateSelection",
          false
        ),

        [BaseEventProps.SELECTION_SOURCE]: get(data, "payload.selectionSource"),
        [BaseEventProps.TRACK_NAME]: get(data, "payload.race.track.trackName"),
        [ModuleEventProps.RACE_STATUS]: get(data, "payload.race.status.code"),
        [ModuleEventProps.MTP]: get(data, "payload.race.mtp"),
        [BaseEventProps.RACE_NUMBER]: get(data, "payload.race.raceNumber"),
        [BaseEventProps.BET_TYPE]: get(data, "payload.betType"),
        [ModuleEventProps.FDTV_TYPE]: get(data, "payload.fdtvType", "no_fdtv"),
        [BaseEventProps.SPECIAL_WAGER_TYPE]: data.payload.specialWagerType
      });
    }
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.RUNNER_SELECTION,
    (data: ProgramPageData) => {
      track<EventProps>(get(data, "payload.action"), {
        [BaseEventProps.EVENT_CATEGORY]: "Bet",
        [ModuleEventProps.PLACE_TYPE]: get(data, "payload.label"),
        [BaseEventProps.MODULE]: get(data, "payload.module"),
        [BaseEventProps.TRACK_NAME]: get(data, "payload.race.track.trackName"),
        [BaseEventProps.RACE_NUMBER]: get(data, "payload.race.raceNumber"),
        [ModuleEventProps.RACE_STATUS]: get(data, "payload.race.status.code"),
        [ModuleEventProps.MTP]: get(data, "payload.race.mtp"),
        [BaseEventProps.BET_TYPE]: get(data, "payload.betType"),
        [ModuleEventProps.FDTV_TYPE]: get(data, "payload.fdtvType", "no_fdtv")
      });
    }
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.SELECT_ALL_RUNNERS,
    (data: ProgramPageData) => {
      track<EventProps>(
        data.payload.add ? "Add To Betslip" : "Remove Selection From Betslip",
        {
          [BaseEventProps.EVENT_CATEGORY]: "Bet",
          ...(data.payload.add
            ? { [ModuleEventProps.PLACE_TYPE]: "All Runners" }
            : { [BaseEventProps.EVENT_LABEL]: "All Runners" }),
          [BaseEventProps.MODULE]: "Race Card",
          [BaseEventProps.RUNNER_SELECTION_LIST]: get(data, "payload.tag"),
          [BaseEventProps.TRACK_NAME]: get(
            data,
            "payload.race.track.trackName"
          ),
          [BaseEventProps.RACE_NUMBER]: get(data, "payload.race.raceNumber"),
          [ModuleEventProps.RACE_STATUS]: get(data, "payload.race.status.code"),
          [ModuleEventProps.MTP]: get(data, "payload.race.mtp"),
          [BaseEventProps.BET_TYPE]: get(data, "payload.betType"),
          [ModuleEventProps.FDTV_TYPE]: get(data, "payload.fdtvType", "no_fdtv")
        }
      );
    }
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.RESET_ALL_RUNNERS,
    (data: ProgramPageData) => {
      track<EventProps>(EVENT_NAME.RESET_ALL_RUNNERS, {
        [BaseEventProps.EVENT_CATEGORY]: "Bet",
        [BaseEventProps.EVENT_LABEL]: "Reset",
        [BaseEventProps.MODULE]: "Race Card",
        [BaseEventProps.RUNNER_SELECTION_LIST]: get(data, "payload.tag"),
        [BaseEventProps.TRACK_NAME]: get(data, "payload.trackName"),
        [BaseEventProps.RACE_NUMBER]: get(data, "payload.race.raceNumber"),
        [ModuleEventProps.RACE_STATUS]: get(data, "payload.race.status.code"),
        [ModuleEventProps.MTP]: get(data, "payload.race.mtp"),
        [BaseEventProps.BET_TYPE]: get(data, "payload.betType"),
        [ModuleEventProps.FDTV_TYPE]: get(data, "payload.fdtvType", "no_fdtv")
      });
    }
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.SELECT_BET_TYPE,
    (data: ProgramPageData) => {
      track<EventProps>(EVENT_NAME.SELECT_BET_TYPE, {
        [BaseEventProps.EVENT_CATEGORY]: "bet selector",
        [BaseEventProps.EVENT_LABEL]: data.payload?.betType,
        [BaseEventProps.MODULE]: "bet_selector",
        [BaseEventProps.RACE_NUMBER]: data.payload?.raceNumber,
        [BaseEventProps.TRACK_NAME]: data.payload?.trackName,
        [ModuleEventProps.MTP]: data.payload?.race?.mtp,
        [ModuleEventProps.RACE_STATUS]: data.payload?.race?.status?.code,
        [ModuleEventProps.FDTV_TYPE]: data.payload?.fdtvType
      });
    }
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.SET_BET_AMOUNT,
    (data: ProgramPageData) => {
      track<EventProps>(EVENT_NAME.BETSLIP_BET_AMOUNT_SELECTED, {
        [BaseEventProps.EVENT_CATEGORY]: "Bet",
        [BaseEventProps.EVENT_LABEL]: get(data, "payload.label"),
        [BaseEventProps.MODULE]: "Bet Modal"
      });
    }
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.BET_TIMEOUT,
    (data: ProgramPageData) => {
      track<EventProps>(EVENT_NAME.BET_TIMEOUT, {
        [BaseEventProps.EVENT_CATEGORY]: "Bet",
        [BaseEventProps.MODULE]: "Confirm Bet Modal",
        [BaseEventProps.RUNNER_SELECTION_LIST]: get(data, "payload.selections"),
        [BaseEventProps.RACE_TRACK_SELECTION]: get(data, "payload.trackName"),
        [BaseEventProps.RACE_NUMBER_SELECTION]: get(
          data,
          "payload.race.raceNumber"
        ),
        [BaseEventProps.BET_AMOUNT]: get(data, "payload.betAmount"),
        [BaseEventProps.BET_TYPE]: get(data, "payload.betType"),
        [BaseEventProps.REPEAT_BET]: get(data, "payload.repeatBet")
      });
    }
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.BET_NOW,
    (data: ProgramPageData) => {
      track<EventProps>(EVENT_NAME.BET_NOW, {
        [BaseEventProps.EVENT_CATEGORY]: "Bet",
        [BaseEventProps.MODULE]: "Bet Modal",
        [BaseEventProps.RACE_TRACK_SELECTION]: get(data, "payload.trackName"),
        [BaseEventProps.RACE_NUMBER_SELECTION]: get(
          data,
          "payload.race.raceNumber"
        ),
        [BaseEventProps.BET_TYPE]: get(data, "payload.betType"),
        [BaseEventProps.SELECTION_SOURCE]: get(data, "payload.selectionSource")
      });
    }
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.DELETE_BET_TICKET,
    () => {
      track<EventProps>(EVENT_NAME.DELETE_BET_TICKET, {
        [BaseEventProps.EVENT_CATEGORY]: "Bet",
        [BaseEventProps.MODULE]: "Bet Modal"
      });
    }
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.OPEN_RACE_NAVIGATION,
    (data: ProgramPageData) => {
      track<EventProps>(EVENT_NAME.OPEN_RACE_NAVIGATION, {
        [BaseEventProps.EVENT_CATEGORY]: COMMON_EVENT_NAMES.SITE_CLICK,
        [BaseEventProps.EVENT_LABEL]: `Race Modal - ${get(
          data,
          "payload.trackName"
        )} - R${get(data, "payload.raceNumber")}`,
        [BaseEventProps.MODULE]: get(data, "payload.module"),
        [ModuleEventProps.FDTV_TYPE]: get(data, "payload.fdtvType", "no_fdtv"),
        [ModuleEventProps.MTP]: get(data, "payload.mtp", 0),
        [ModuleEventProps.RACE_STATUS]: get(data, "payload.raceStatus", ""),
        [BaseEventProps.TRACK_NAME]: get(data, "payload.trackName"),
        [BaseEventProps.RACE_NUMBER]: get(data, "payload.raceNumber")
      });
    }
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.HANDICAP_STORE_PRODUCT,
    (data: ProgramPageData) => {
      track<EventProps>(EVENT_NAME.HANDICAP_STORE_PRODUCT, {
        [BaseEventProps.EVENT_CATEGORY]: COMMON_EVENT_NAMES.SITE_CLICK,
        [BaseEventProps.EVENT_LABEL]: get(data, "payload.product"),
        [BaseEventProps.MODULE]: "PP Trackmaster Picks",
        [BaseEventProps.TRACK_NAME]: get(data, "payload.trackName"),
        [BaseEventProps.RACE_NUMBER]: get(data, "payload.raceNumber"),
        [ModuleEventProps.RACE_STATUS]: get(data, "payload.raceStatus"),
        [ModuleEventProps.MTP]: get(data, "payload.mtp"),
        [ModuleEventProps.FDTV_TYPE]: get(data, "payload.fdtvType")
      });
    }
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.PROGRAM_RUNNER_INFO_MODAL_OPENED,
    (data: ProgramPageData) => {
      track<EventProps>(EVENT_NAME.PROGRAM_RUNNER_INFO_MODAL_OPENED, {
        [BaseEventProps.EVENT_CATEGORY]: "Program",
        [BaseEventProps.RACE_NUMBER]: get(data, "raceNumber"),
        [BaseEventProps.TRACK_NAME]: get(data, "trackName"),
        [BaseEventProps.RUNNER_NAME]: get(data, "runnerName"),
        [BaseEventProps.RUNNER_TAGS_VISIBLE]: get(data, "runnerTagsVisible"),
        [BaseEventProps.MODULE]: "Runner Call Outs",
        [ModuleEventProps.MTP]: get(data, "payload.raceMtp"),
        [ModuleEventProps.RACE_STATUS]: get(data, "payload.raceStatus"),
        [ModuleEventProps.FDTV_TYPE]: get(data, "payload.fdtvType")
      });
    }
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.PROGRAM_RUNNER_INFO_MODAL_CLOSED,
    (data: ProgramPageData) => {
      track<EventProps>(EVENT_NAME.PROGRAM_RUNNER_INFO_MODAL_CLOSED, {
        [BaseEventProps.EVENT_CATEGORY]: "Program",
        [BaseEventProps.RACE_NUMBER]: get(data, "raceNumber"),
        [BaseEventProps.TRACK_NAME]: get(data, "trackName"),
        [BaseEventProps.RUNNER_NAME]: get(data, "runnerName"),
        [BaseEventProps.RUNNER_TAGS_VISIBLE]: get(data, "runnerTagsVisible"),
        [BaseEventProps.MODULE]: "Runner Call Outs",
        [ModuleEventProps.MTP]: get(data, "payload.raceMtp"),
        [ModuleEventProps.RACE_STATUS]: get(data, "payload.raceStatus"),
        [ModuleEventProps.FDTV_TYPE]: get(data, "payload.fdtvType")
      });
    }
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.HANDICAP_STORE_SEE_ALL,
    (data: ProgramPageData) => {
      track<EventProps>(EVENT_NAME.HANDICAP_STORE_SEE_ALL, {
        [BaseEventProps.EVENT_CATEGORY]: "Navigation",
        [BaseEventProps.LINK_TEXT]: "see all products",
        [BaseEventProps.MODULE]: "PP Trackmaster Picks",
        [BaseEventProps.LINK_URL]: get(data, "payload.destinationUrl"),
        [BaseEventProps.RACE_NUMBER]: get(data, "payload.raceNumber"),
        [BaseEventProps.TRACK_NAME]: get(data, "payload.trackName"),
        [ModuleEventProps.MTP]: get(data, "payload.raceMtp"),
        [ModuleEventProps.RACE_STATUS]: get(data, "payload.raceStatus"),
        [ModuleEventProps.FDTV_TYPE]: get(data, "payload.fdtvType")
      });
    }
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.RUNNER_MODIFIER_FILTER_APPLIED,
    (data: ProgramPageData) => {
      track<EventProps>(EVENT_NAME.RUNNER_MODIFIER_FILTER_APPLIED, {
        [BaseEventProps.EVENT_CATEGORY]: "Program",
        [BaseEventProps.EVENT_LABEL]: get(data, "payload.filter"),
        [BaseEventProps.MODULE]: "Runner Modifier",
        [ModuleEventProps.FILTER_TYPE]: "Runner Modifier",
        [BaseEventProps.FILTER_VALUE]: get(data, "payload.filter"),
        [BaseEventProps.TRACK_NAME]: get(data, "payload.trackName"),
        [BaseEventProps.RACE_NUMBER]: get(data, "payload.raceNumber"),
        [ModuleEventProps.RACE_STATUS]: get(data, "payload.raceStatus"),
        [ModuleEventProps.MTP]: get(data, "payload.raceMtp"),
        [ModuleEventProps.FDTV_TYPE]: get(data, "payload.fdtvType")
      });
    }
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.RUNNER_MODIFIER_SORT_APPLIED,
    (data: ProgramPageData) => {
      track<EventProps>(EVENT_NAME.RUNNER_MODIFIER_SORT_APPLIED, {
        [BaseEventProps.EVENT_CATEGORY]: "Program",
        [BaseEventProps.EVENT_LABEL]: get(data, "payload.sortOperation"),

        [BaseEventProps.MODULE]: "Runner Modifier",
        [BaseEventProps.RACE_NUMBER]: get(data, "payload.raceNumber"),
        [BaseEventProps.TRACK_NAME]: get(data, "payload.trackName"),
        [ModuleEventProps.SORT_TYPE]: "Runner Modifier",
        [ModuleEventProps.SORT_NAME]: get(data, "payload.sortValue"),
        [ModuleEventProps.SORT_OPERATION]: get(data, "payload.sortOperation"),
        [ModuleEventProps.RACE_STATUS]: get(data, "payload.raceStatus"),
        [ModuleEventProps.MTP]: get(data, "payload.raceMtp"),
        [ModuleEventProps.FDTV_TYPE]: get(data, "payload.fdtvType")
      });
    }
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.WILL_PAYS_SELECT_OPTION,
    (data: ProgramPageData) => {
      track<EventProps>(EVENT_NAME.WILL_PAYS_SELECT_OPTION, {
        [BaseEventProps.EVENT_CATEGORY]: "Program",
        [BaseEventProps.EVENT_LABEL]: get(data, "payload.label"),
        [BaseEventProps.MODULE]: "Will Pays",
        [BaseEventProps.TRACK_NAME]: get(data, "payload.trackName"),
        [BaseEventProps.RACE_NUMBER]: get(data, "payload.race.raceNumber"),
        [ModuleEventProps.RACE_STATUS]: get(data, "payload.raceStatus"),
        [ModuleEventProps.MTP]: get(data, "payload.raceMtp"),
        [ModuleEventProps.FDTV_TYPE]: get(data, "payload.fdtvType")
      });
    }
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.PROBABLES_SELECT_OPTION,
    (data: ProgramPageData) => {
      track<EventProps>(EVENT_NAME.PROBABLES_SELECT_OPTION, {
        [BaseEventProps.EVENT_CATEGORY]: "Program",
        [BaseEventProps.EVENT_LABEL]: get(data, "payload.label"),
        [BaseEventProps.MODULE]: "Probables",
        [BaseEventProps.TRACK_NAME]: get(data, "payload.trackName"),
        [BaseEventProps.RACE_NUMBER]: get(data, "payload.race.raceNumber"),
        [ModuleEventProps.RACE_STATUS]: get(data, "payload.raceStatus"),
        [ModuleEventProps.MTP]: get(data, "payload.raceMtp"),
        [ModuleEventProps.FDTV_TYPE]: get(data, "payload.fdtvType")
      });
    }
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.FAVORITE_INTERACTION,
    (data: ProgramPageData) =>
      track<EventProps>(
        get(data, "payload.isFavorite")
          ? EVENT_NAME.FAVORITED
          : EVENT_NAME.UNFAVORITED,
        {
          [BaseEventProps.MODULE]: "Race Card",
          [BaseEventProps.RACE_NUMBER]: get(data, "payload.race.raceNumber"),
          [BaseEventProps.TRACK_NAME]: get(
            data,
            "payload.race.track.trackName"
          ),
          [ModuleEventProps.MTP]: get(data, "payload.race.mtp"),
          [ModuleEventProps.RACE_STATUS]: get(data, "payload.race.status.code"),
          [ModuleEventProps.FDTV_TYPE]: get(data, "payload.fdtvType")
        }
      )
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.POOLS_AND_INFO_MODAL_OPENED,
    (data: ProgramPageData) => {
      track<EventProps>(EVENT_NAME.POOLS_AND_INFO_MODAL_OPENED, {
        [BaseEventProps.MODULE]: "Race Card",
        [BaseEventProps.RACE_NUMBER]: get(data, "payload.race.raceNumber"),
        [BaseEventProps.TRACK_NAME]: get(data, "payload.race.track.trackName"),
        [ModuleEventProps.MTP]: get(data, "payload.race.mtp"),
        [ModuleEventProps.RACE_STATUS]: get(data, "payload.race.status.code"),
        [ModuleEventProps.FDTV_TYPE]: get(data, "payload.fdtvType")
      });
    }
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.POOLS_AND_INFO_MODAL_OPENED,
    () => {
      track<EventProps>(EVENT_NAME.POOLS_AND_INFO_MODAL_OPENED, {
        [BaseEventProps.MODULE]: "Race Card"
      });
    }
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.POOLS_AND_INFO_TAB_OPENED,
    (data: ProgramPageData) =>
      track<EventProps>(EVENT_NAME.POOLS_AND_INFO_TAB_OPENED, {
        [BaseEventProps.MODULE]: "pools_and_info",
        [BaseEventProps.TAB]: get(data, "payload.label"),
        [BaseEventProps.TRACK_NAME]: get(data, "payload.trackName"),
        [BaseEventProps.RACE_NUMBER]: get(data, "payload.raceNumber"),
        [ModuleEventProps.MTP]: get(data, "payload.race.mtp"),
        [ModuleEventProps.RACE_STATUS]: get(data, "payload.race.status.code"),
        [ModuleEventProps.FDTV_TYPE]: get(data, "payload.fdtvType")
      })
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.HANDICAPPING_TAB_OPENED,
    (data: ProgramPageData) =>
      track<EventProps>(EVENT_NAME.HANDICAPPING_TAB_OPENED, {
        [BaseEventProps.MODULE]: "program_handicapping",
        [BaseEventProps.TAB]: get(data, "payload.label"),
        [BaseEventProps.TRACK_NAME]: get(data, "payload.trackName"),
        [BaseEventProps.RACE_NUMBER]: get(data, "payload.raceNumber"),
        [ModuleEventProps.RACE_STATUS]: get(data, "payload.raceStatus"),
        [ModuleEventProps.MTP]: get(data, "payload.raceMtp"),
        [ModuleEventProps.FDTV_TYPE]: get(data, "payload.fdtvType")
      })
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.RUNNER_TAGS_EXPANDED,
    (data: ProgramPageData) =>
      track<EventProps>(EVENT_NAME.RUNNER_TAGS_EXPANDED, {
        [BaseEventProps.MODULE]: "runner_details",
        [BaseEventProps.RUNNER_NAME]: get(data, "payload.runnerName"),
        [BaseEventProps.TRACK_NAME]: get(data, "payload.trackName"),
        [BaseEventProps.RACE_NUMBER]: get(data, "payload.raceNumber"),
        [ModuleEventProps.MTP]: get(data, "payload.raceMtp"),
        [ModuleEventProps.RACE_STATUS]: get(data, "payload.raceStatus"),
        [ModuleEventProps.FDTV_TYPE]: get(data, "payload.fdtvType")
      })
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.PROGRAM_FREE_PP_DOWNLOAD,
    (data: ProgramPageData) =>
      track<EventProps>(EVENT_NAME.PROGRAM_FREE_PP_DOWNLOAD, {
        [BaseEventProps.RACE_NUMBER]: get(data, "payload.raceNumber"),
        [BaseEventProps.TRACK_NAME]: get(data, "payload.trackName"),
        [BaseEventProps.RACE_TYPE]: get(data, "payload.raceType"),
        [ModuleEventProps.RACE_STATUS]: get(data, "payload.raceStatus"),
        [ModuleEventProps.MTP]: get(data, "payload.raceMtp"),
        [ModuleEventProps.FDTV_TYPE]: get(data, "payload.fdtvType")
      })
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.DROPDOWN_OPEN,
    (data: ProgramPageData) =>
      track<EventProps>(EVENT_NAME.DROPDOWN_OPENED, {
        [BaseEventProps.MODULE]: "race_selector",
        [BaseEventProps.TRACK_NAME]: data.payload.trackName,
        [BaseEventProps.RACE_NUMBER]: data.payload.raceNumber,
        [ModuleEventProps.RACE_STATUS]: get(data, "payload.raceStatus"),
        [ModuleEventProps.MTP]: get(data, "payload.raceMtp"),
        [ModuleEventProps.FDTV_TYPE]: get(data, "payload.fdtvType")
      })
  );

  mediator.base.subscribe(
    ProgramPageMediatorEventType.DROPDOWN_RACE_SELECTED,
    (data: ProgramPageData) =>
      track<EventProps>(EVENT_NAME.DROPDOWN_RACE_SELECTED, {
        [BaseEventProps.MODULE]: "race_selector_dropdown",
        [BaseEventProps.TRACK_NAME]: data.payload.trackName,
        [BaseEventProps.RACE_NUMBER]: data.payload.raceNumber,
        [ModuleEventProps.RACE_STATUS]: get(data, "payload.raceStatus"),
        [ModuleEventProps.MTP]: get(data, "payload.raceMtp"),
        [ModuleEventProps.FDTV_TYPE]: get(data, "payload.fdtvType")
      })
  );
};
